<template>
	<div class="flex" style="padding: 10px 10px 10px 0; overflow: auto;">
		<div class="left" style="width: 120px;text-align: center;">
			<!-- <el-button style="width: 100px;" :type="form.floor == -1 ? 'primary' : ''" @click="setFloor(-1)">
				-1层
			</el-button> -->
			<div v-for="item in floorList">
				<el-button style="width: 100px;margin-top:10px;" :type="item.label == form.floor ? 'primary' : ''"
					@click="setFloor(item)">
					{{ item.label }}层
				</el-button>
			</div>
		</div>
		<div class="center" style="background-color: #fff;padding: 10px ;">
			<el-form ref="form" :model="form" label-width="100px">
				<el-form-item label="业态标签">
					<el-select v-model="form.label" placeholder="请选择" multiple style="width: 100%;">
						<el-option-group v-for="group in options" :key="group.label" :label="group.label">
							<el-option v-for="item in group.options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-option-group>
					</el-select>
				</el-form-item>
				<el-form-item label="业态规划图">
					<!-- <div>
						<img v-if="form.liquidPictureShowpath" :src="form.liquidPictureShowpath" alt="" 
							 style="border: 1px solid #000000;max-width: 100%;max-height: 100%;">
						<el-upload action="/api/admin/liquidProgramming/uploadPicture" :show-file-list="false"
							v-if="!form.liquidPictureShowpath" :headers="headerData" :on-success="success">
							<i class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</div> -->
					<div class="img-container" @mousedown.stop.prevent>
						<img ref="imgRef" mode="heightFix" :src="require('../../assets/imgs/' + floorCode + 'Y.png')">
						<div class="mark-container" ref="markContainerRef" @mousedown="mousedownEvent($event)"
							@mousemove="moveEvent($event)" @mouseup="mouseUpEvent">
							<div class="point" v-for="(item, index) in pointList" :key="index"
								:style="getPointCoordStyle(item)">
								<!-- https://www.jsitc.net.cn/RoomManage/preview/ICON_LOGIN_PASSWORD2023481B.png -->
								<div @click="bindingCamera(index, item)" @contextmenu.prevent="deletePoint(index, item)"
									:style="`display:flex;align-items:center;`">
								<img v-if="item.showPath&&item.showPath != 'undefined'" style="width:50px;height:50px;" :src="item.showPath"  />
									<div :style="`color: ${item.placeColor};font-size: 16px;margin-left:5px;`">
									{{ item.placeName }}
									</div>
								</div>
							</div>
							<div class="temp-point" v-show="isMovedown" :style="getPointCoordStyle(tempPoint)"></div>
						</div>

					</div>
				</el-form-item>
				<el-form-item>
					<div v-if="roleId == 1 || roleId == 2 || roleId == 5" style="text-align: center;">
						<!-- <el-button
							@click="form.liquidPictureShowpath = ''; form.liquidPicturePath = ''">删除图片</el-button> -->
						<el-button type="primary" @click="onSubmit">保存</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<!-- <div class="right" style="width: 200px;padding: 0 10px;">
			<div>审核状态：不通过</div>
			<div class="b" style="margin: 10px 0;">楼层商铺</div>
			<div class="flex y">
				<span style="white-space: nowrap;">店铺号</span>
				<el-input size="mini"></el-input>
			</div>
			<div class="flex">
				<div class="flex y">
					<span style="font-size: 12px;">入住</span>
					<div style="background-color: #3C98FF;width: 20px;height: 10px;"></div>
				</div>
				<div class="flex y" style="margin: 0 4px;">
					<span style="font-size: 12px;">空闲</span>
					<div style="background-color: #fff;width: 20px;height: 10px;"></div>
				</div>
				<div class="flex y">
					<span style="font-size: 12px;">装修</span>
					<div style="background-color: #55ff7f;width: 20px;height: 10px;"></div>
				</div>
			</div>
			<div style="text-align: center;">
				<div v-for="item in 9" style="border: 1px solid #b0b0b0;width: 60%;margin: 4px 0;padding: 4px 0;">
					10{{item}}</div>
			</div>
		</div> -->
		<el-dialog title="绑定场所" :visible.sync="bindingShow" width="500px" :close-on-click-modal="false"
			:close-on-press-escape="false">
			<el-form ref="form" label-width="80px">
				<el-form-item label="场所名称">
					<el-input v-model="placeName" placeholder="请输入场所名称"></el-input>
				</el-form-item>
				<el-form-item label="字体颜色">
					<el-color-picker v-model="placeColor"
						:predefine="['#409EFF', '#1890ff', '#304156', '#212121', '#11a983', '#13c2c2', '#6959CD', '#f5222d',]">
					</el-color-picker>
				</el-form-item>
				<el-form-item label="图标">
					<el-upload class="avatar-uploader" action="/api/admin/roomManage/uploadRoomPictureFile" :show-file-list="false"
					 :on-success="success2" :headers="headerData" name="file" :before-upload="beforeAvatarUpload">
						<img v-if="showPath" :src="showPath" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						<div class="el-upload__tip" slot="tip">只能上传jpg/png/jpeg文件</div>
					</el-upload>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="bindingShow = false">取 消</el-button>
				<el-button type="primary" @click="submitBinding">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { options } from "./data.js";
export default {
  data() {
    return {
      showPath: "",
      placeColor: "",
      bindingShow: false,
      placeName: "",
      pointList: [],
      pointDataList: [],
      tempPoint: {
        id: "",
        x: 0,
        y: 0,
        placeName: "",
        placeColor: "",
      },
      pointWidth: 30,
      rect: {}, //div
      imgNaturalData: {
        //图片真实数据
        width: 0,
        height: 0,
      },
      isMovedown: false, //鼠标是否按下
      headerData: {
        Authorization: localStorage.access_token,
      },
      form: {
        floor: -1,
        label: "",
        liquidPicturePath: "",
        liquidPictureShowpath: "",
      },
      options,
      type: "",
      roleId: "",
      floorCode: "1020",

      floorList: [
        {
          label: "-1",
          value: "1020",
        },
        {
          label: "1",
          value: "1030",
        },
        {
          label: "2",
          value: "1040",
        },
        {
          label: "3",
          value: "1050",
        },
        {
          label: "4",
          value: "1060",
        },
      ],
    };
  },
  computed: {
    // 计算属性
    getPointCoordStyle() {
      return (item) => {
        if (item.x) {
          return {
            left: item.x - this.pointWidth / 2 + "px",
            top: item.y - this.pointWidth / 2 + "px",
          };
        } else {
          return {
            left: item.xAxis - this.pointWidth / 2 + "px",
            top: item.yAxis - this.pointWidth / 2 + "px",
          };
        }
      };
    },
  },
  mounted() {
    document.addEventListener("mouseup", this.docMouseUp);
    document.addEventListener("mousemove", this.docMouseMove);
    window.addEventListener("resize", this.addWindowResize);
    this.roleId = sessionStorage.roleId;
    console.log(sessionStorage.roleId);
    this.setFloor({
      label: "-1",
      value: "1020",
    });
  },
  methods: {
    //上传图片
    beforeAvatarUpload(file) {
      var isJPG = null;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg"
      ) {
        isJPG = true;
      } else {
        isJPG = false;
      }
      // const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传Logo只能是 JPG/JPEG/PNG 格式!");
      }
      // if (!isLt2M) {
      // 	this.$message.error('上传图片大小不能超过 1MB!');
      // }
      // return isLt2M && isJPG;
      return isJPG;
    },
    setFloor(item) {
      this.form.floor = item.label;
      this.floorCode = item.value;
      this.$http
        .get(
          `/api/liquidProgramming/findLiquidProgramming?floor=${
            this.form.floor
          }层`
        )
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data != null) {
              this.type = "修改";
              this.form.label = JSON.parse(res.data.data.label);
              this.form.id = res.data.data.id;
              this.form.liquidPicturePath = res.data.data.liquidPicturePath;
              this.form.liquidPictureShowpath =
                res.data.data.liquidPictureShowpath;
            } else {
              this.type = "新增";
              this.form.label = "";
              this.form.liquidPicturePath = "";
              this.form.liquidPictureShowpath = "";
            }
          }
        });
      this.getDataList();
    },
    onSubmit() {
      if (this.form.floor == "") {
        this.$message.warning("请选择楼层");
        return;
      }
      if (this.form.label == "") {
        this.$message.warning("请选择标签");
        return;
      }
      if (this.form.liquidPicturePath == "") {
        this.$message.warning("请选择图片");
        return;
      }
      this.form.label = JSON.stringify(this.form.label);

      let url = "/api/liquidProgramming/addLiquidProgramming";
      if (this.type == "修改") {
        url = "/api/liquidProgramming/editLiquidProgramming";
      }
      this.$http
        .post(url, {
          ...this.form,
          floor: this.form.floor + "层",
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.setFloor(this.form.floor);
            this.$message.success(`${this.type}成功`);
          } else {
            this.$message.error(`${this.type}失败`);
          }
        });
    },
    success2(res) {
      console.log(res);
      if (res.code == 0) {
        this.$message.success("上传成功");
        this.showPath = res.data.showPath;
      } else {
        this.$message.error("上传失败");
      }
    },
    success(res) {
      if (res.code == 0) {
        this.$message.success("上传成功");
        this.form.liquidPicturePath = res.data.avatarPath;
        this.form.liquidPictureShowpath = res.data.previewPath;
      } else {
        this.$message.error("上传失败");
      }
    },
    getDataList() {
      this.pointList = [];
      this.pointDataList = [];
      this.$http
        .get("/api/liquidProgramming/getBusinessLabel?floor=" + this.form.floor)
        .then((res) => {
          if (res.data.code == "0") {
            // this.dataList = res.data.data
            res.data.data.forEach((element) => {
              if (element.yAxis) {
                this.pointDataList.push(element);
              }
            });
            this.loadImage();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },

    mousedownEvent(e) {
      //获取坐标
      if (e.target.className == "point") {
        let dom = this.$refs.markContainerRef;
        if (e.target == dom.firstChild) {
          this.isMovedown = true;
          this.rect = this.$refs.markContainerRef.getBoundingClientRect();
          this.tempPoint = {
            x: e.pageX - this.rect.x,
            y: e.pageY - this.rect.y,
          };
        }
      }
      if (e.target == this.$refs.markContainerRef) {
        this.isMovedown = true;
        this.rect = this.$refs.markContainerRef.getBoundingClientRect();
        this.tempPoint = {
          x: e.pageX - this.rect.x,
          y: e.pageY - this.rect.y,
        };
      }
    },
    moveEvent(e) {
      //鼠标移动事件
      if (this.isMovedown) {
        let rx = e.pageX - this.rect.x;
        let ry = e.pageY - this.rect.y;

        if (
          0 <= rx &&
          rx <= this.rect.width &&
          0 <= ry &&
          ry <= this.rect.height
        ) {
          this.tempPoint = {
            x: e.pageX - this.rect.x,
            y: e.pageY - this.rect.y,
          };
        }
      }
    },
    deletePoint(index, item) {
      //点击删除选中的点
      this.$confirm("是否确定删除该位置?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            id: item.id + "",
          };
          this.$http
            .delete("/api/liquidProgramming/deleteBusinessLabel?id=" + item.id)
            .then((res) => {
              if (res.data.code == "0") {
                this.$message.success(res.data.message);
                this.getDataList();
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
      return;
    },
    docMouseMove() {},
    mouseUpEvent() {
      // ('区域抬起')
      if (this.isMovedown == true) {
        this.tempPoint.x = Math.round(this.tempPoint.x * 100) / 100;
        this.tempPoint.y = Math.round(this.tempPoint.y * 100) / 100;
        this.bindingShow = true;
        this.placeName = "";
        this.placeColor = "";
        this.showPath = "";
        // this.tempPoint.placeName = "待绑定"
      }
      this.isMovedown = false;
    },
    bindingCamera(index, item) {
      // if (item.placeName != "待绑定") {
      // 	this.$message.error("已绑定场所！")
      // 	return
      // }
      this.tempPoint = item;
      this.showPath = item.showPath;
      this.placeName = item.placeName;
      this.placeColor = item.placeColor;
      this.bindingShow = true;
    },
    submitBinding() {
      if (this.placeName == "") {
        this.$message.error("请输入名称");
        return;
      }
      if (this.showPath == "" || this.showPath == "undefined") {
        this.$message.error("请上传logo");
        return;
      }
      let placeColor = "#FFFFFF";
      if (this.placeColor != "") {
        placeColor = this.placeColor;
      }
      let data = {
        id: this.tempPoint.id, //（有id是修改，无id是新增）
        floor: this.form.floor, // 楼层
        xaxis: this.tempPoint.x, // x轴
        yaxis: this.tempPoint.y, //  y轴
        name: this.placeName + ";" + placeColor + ";" + this.showPath, //  名称
      };
      this.$http
        .post("/api/liquidProgramming/editBusinessLabel", data)
        .then((res) => {
          if (res.data.code == "0") {
            this.$message.success(res.data.message);
            this.bindingShow = false;
            this.getDataList();
          } else {
            this.$message.error(res.data.message);
          }
        });
      // this.pointList.push(this.tempPoint);
      // this.bindingShow = false;
    },
    docMouseUp() {
      this.isMovedown = false;
    },
    loadImage() {
      //加载完图片回调
      let imgRef = this.$refs.imgRef; //img的dom
      //有真实图片款高用注释部分，没有就用标签高度
      this.imgNaturalData.width = imgRef.naturalWidth; //图片原始宽度
      this.imgNaturalData.height = imgRef.naturalHeight; //图片原始高度
      // this.imgNaturalData.width = imgRef.width; //图片标签宽度
      // this.imgNaturalData.height = imgRef.height; //图片标签高度
      this.rect = this.$refs.imgRef.getBoundingClientRect();
      this.imgScale = this.rect.width / this.imgNaturalData.width; //现在图片和真实图片比例
      this.handlePointListData(this.imgScale);
    },
    handlePointListData(imgScale) {
      console.log(this.pointDataList);
      // this.pointList = this.pointDataList
      this.pointList = [];
      this.pointDataList.forEach((item) => {
        if (item.name) {
          let data = {
            id: item.id,
            x: item.xAxis,
            y: item.yAxis,
            placeName: item.name.split(";")[0],
            placeColor: item.name.split(";")[1],
            showPath: item.name.split(";")[2],
          };
          this.pointList.push(data);
        }
      });
      console.log(this.pointList);
      console.log(this.pointList);
      console.log(this.pointList);
      console.log(this.pointList);
      console.log(this.pointList);
    },
    addWindowResize() {
      //屏幕宽度改变
      this.rect = this.$refs.imgRef.getBoundingClientRect();
      this.imgScale = this.rect.width / this.imgNaturalData.width;
      this.handlePointListData(this.imgScale);
    },

    computeAngle(y, x) {
      let t = Math.atan2(y, x);
      return (t / Math.PI) * 180;
    },
    indexMethod(index) {
      return index + 1;
    },
  },
  beforeDestroy() {
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    document.removeEventListener("mouseup", this.docMouseUp);
    document.removeEventListener("mousemove", this.docMouseMove);
    window.removeEventListener("resize", this.addWindowResize);
  },
};
</script>

<style scoped="scoped">
.avatar-uploader .el-upload {
  width: 100%;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.region-container {
  display: flex;
}

.img-container {
  border: 1px solid #c6c6c6;
  position: relative;
  margin-left: 15px;
  height: 510px;
}

.img-container img {
  height: 100%;
  display: block;
  position: relative;
}

.mark-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  z-index: 99;
}

.line-container {
  height: 100%;
  position: absolute;
  top: 0px;
  z-index: 80;
}

.line-container .line {
  height: 3px;
  background-color: red;
  position: absolute;
}

/* .line-container .line{
    width: 200px;
    height: 3px;
    background-color: red;
    transform: rotateZ(45deg);
    position: absolute;
    left: 40px;
    top: 200px;
  } */

.point,
.temp-point {
  /* width: 8px;
	height: 8px; */
  /* background-color: red; */
  border-radius: 50%;
  position: absolute;
  /* top: 30px;
    left: 50px; */
  cursor: pointer;
}

.point-info-container {
  margin-left: 20px;
  /* background-color: azure; */
}

.point-info-container .item {
  margin-top: 10px;
}

.item .x-coord {
  width: 100px;
}

.item .y-coord {
  width: 80px;
}

.btn-container {
  margin-left: 330px;
}
</style>
